import React, { Component } from 'react';
import '../css/skills.css';
import  Nav from './nav'




class Skills extends Component {
render(){
return(<div>
<Nav/>
<div id="backgroundS">


<div class="container conta">


<div class="row">

<div class="col-md-12" >
<center>
<h1 id="titules5" >HABILIDADES</h1>
</center>
</div>

</div>


 
<div class="row">

    <div class=" col-md-12 " >
    
    
    <center>
   
    <div class="skills"><i class="fab yellow-text fa-js-square pl-4 pr-4 pl-md-5 pr-md-5 size-icon" ></i><b><p class="pt-3">Javascript</p></b></div>
    <div class="skills"><i class="fab yellow-text fa-react pl-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">React</p></b></div>
    <div class="skills"><i class="fab yellow-text fa-github pl-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">GitHub</p></b></div>
    <div class="skills"><i class="fas yellow-text fa-database pl-4 pr-4 pl-md-5 pr-md-5 size-icon" ></i><b><p class="pt-3">Firebase</p></b></div>
    <div class="skills"><i class=" yellow-text fas fa-history pl-4 pr-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">Metodologías Ágiles</p></b></div>
    <div class="skills"><i class=" yellow-text fas fa-book-reader pl-4 pr-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">Autodidacta</p></b></div>
    <div class="skills"><i class=" yellow-text fas fa-comments pl-4 pr-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">Comunicación efectiva</p></b></div>
    <div class="skills"><i class=" yellow-text fas fa-users pl-4 pr-4 pr-4 pl-md-5 pr-md-5 size-icon"></i><b><p class="pt-3">Adaptabilidad</p></b></div>
    
</center>
  </div>
   
  </div>

  </div>
  </div>


</div>



);
}
}
export default Skills;